import { useRef } from 'react';

export const useDebounce = <T>(
  callback: (...args: any[]) => T,
  delay: number = 500
) => {
  const clearRef = useRef<NodeJS.Timeout>(null);
  return (...args: any[]) => {
    if (clearRef.current) clearTimeout(clearRef.current);
    clearRef.current = setTimeout(() => {
      callback(...args);
    }, delay);
  };
};

export default useDebounce;
